import React, { useEffect, useMemo, useState } from 'react'
import { useAlert } from 'react-alert'

import {
  BlockApplicationModel,
  ScreenplaysModel
} from '../../../../../domain/models'
import {
  deleteDetailingScreenplay,
  fetchDetailingScreenplay,
  fetchScreenplay,
  saveDetailingScreenplay,
  updateDetailingScreenplay
} from '../../../../../main/usecases'

import { dateToday } from '../../../../utils'
import { useModalBox } from '../../../../contexts'
import { Button, Input } from '../../../../components'

import {
  ArrowRightSvg,
  IconSaveSvg,
  IconTrashSvg
} from '../../../../assets/icons/svgComponents'

import * as S from './styles'

type ModelsModalProps = {
  blocksInScreen: any
  dispatch: any
}

const ModelsModal = ({ blocksInScreen, dispatch }: ModelsModalProps) => {
  const [screenplays, setScreenplays] = useState<ScreenplaysModel[]>([])
  const [valuesCustomBlockModal, setValuesCustomBlockModal] = useState<any>({
    blocosAplicados: []
  })
  const [newScreenplayTitle, setNewScreenplayTitle] = useState('')
  const [loading, setLoading] = useState(false)
  const alert = useAlert()
  const { modalClose } = useModalBox()

  const screenplaysSuggested = useMemo(() => {
    const filterScreenplays = screenplays
      .filter((item) => !item.psicologo)
      .map((screenplay) => screenplay)

    return filterScreenplays
  }, [screenplays])

  const screenplaysCustom = useMemo(() => {
    const filterScreenplays = screenplays
      .filter((item) => item.psicologo)
      .map((screenplay) => screenplay)

    return filterScreenplays
  }, [screenplays])

  useEffect(() => {
    ;(async () => {
      try {
        const responseScreenplay = await fetchScreenplay().load()

        setScreenplays(responseScreenplay)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  useEffect(() => {
    try {
      setLoading(true)

      if (valuesCustomBlockModal?.blocosAplicados?.length) {
        dispatch({ type: 'load', response: valuesCustomBlockModal })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [valuesCustomBlockModal, dispatch])

  const handleRemoveBlock = async () => {
    blocksInScreen.forEach((item: any) => {
      dispatch({ type: 'delete', position: item.position })
    })
  }

  const LoadBlockModal = async (id: number) => {
    try {
      setLoading(true)
      const response = await fetchDetailingScreenplay({
        cdScreenplayTest: id
      }).load()

      const body = response.map((item: any) => {
        return {
          cdRoteiroTesteDetalhamento: item?.cdRoteiroTesteDetalhamento,
          roteiroTeste: {
            cdRoteiroTeste: item?.roteiroTeste?.cdRoteiroTeste,
            roteiroTeste: item?.roteiroTeste?.roteiroTeste
          },
          construto: {
            cdConstruto: item?.construto?.cdConstruto,
            construto: item?.construto?.construto,
            categoriaConstruto: item?.construto?.categoriaConstruto
          },
          resultadoTeste: {
            construto: item?.construto?.cdConstruto,
            customTeste: item?.customTeste,
            teste: item?.teste?.cdTeste
              ? {
                  cdTeste: item?.teste?.cdTeste
                }
              : undefined,
            ...(item.controleGeral && {
              controleGeral: item.controleGeral
            }),
            ...(item.afetividade && {
              afetividade: item.afetividade
            }),
            ...(item.organizacaoDaPersonalidade && {
              organizacaoDaPersonalidade: item.organizacaoDaPersonalidade
            }),
            ...(item.agressividade && {
              agressividade: item.agressividade
            }),
            ...(item.maturidadeEEmotividade && {
              maturidadeEEmotividade: item.maturidadeEEmotividade
            }),
            ...(item.impulsividade && {
              impulsividade: item.impulsividade
            }),
            ...(item.relacionamentoInterpessoal && {
              relacionamentoInterpessoal: item.relacionamentoInterpessoal
            }),
            ...(item.energiaVitalProdutividade && {
              energiaVitalProdutividade: item.energiaVitalProdutividade
            }),
            ...(item.alterecaoPsiquicas && {
              alterecaoPsiquicas: item.alterecaoPsiquicas
            }),
            incluirBloco: item?.customTeste ? false : item?.incluirBloco,
            numeroPontos: item?.numeroPontos,
            percentil: item?.percentil,
            resultado: item?.resultado,
            observacao: item?.observacao,
            data: item?.data ? item?.data : dateToday
          }
        }
      })

      alert.show('Carregado', {
        type: 'success',
        timeout: 4000
      })
      setValuesCustomBlockModal({ blocosAplicados: [...body] })
      modalClose()
    } catch (error) {
      console.error(error)
      alert.show('Erro ao carregar modelo', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteScreenplay = async (id: number) => {
    try {
      setLoading(true)
      await deleteDetailingScreenplay({ cdScreenplayTest: id }).delete()
      alert.show('Deletado', {
        type: 'success',
        timeout: 4000
      })
      modalClose()
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar modelo', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  const updateScreenplay = async () => {
    const body = {
      roteiroTeste: {
        cdRoteiroTeste: blocksInScreen[0]?.roteiroTeste.cdRoteiroTeste
      },
      roteiroTesteDetalhamento: blocksInScreen.map((item: any) => {
        return {
          ...(item.cdRoteiroTesteDetalhamento && {
            cdRoteiroTesteDetalhamento: item?.cdRoteiroTesteDetalhamento
          }),
          construto: {
            cdConstruto: item?.construto?.cdConstruto
          },
          customTeste: item?.resultadoTeste?.customTeste,
          teste: item?.resultadoTeste?.teste?.cdTeste
            ? {
                cdTeste: item?.resultadoTeste?.teste?.cdTeste
              }
            : undefined,
          ...(item.resultadoTeste.controleGeral && {
            controleGeral: item.resultadoTeste.controleGeral
          }),
          ...(item.resultadoTeste.afetividade && {
            afetividade: item.resultadoTeste.afetividade
          }),
          ...(item.resultadoTeste.organizacaoDaPersonalidade && {
            organizacaoDaPersonalidade:
              item.resultadoTeste.organizacaoDaPersonalidade
          }),
          ...(item.resultadoTeste.agressividade && {
            agressividade: item.resultadoTeste.agressividade
          }),
          ...(item.resultadoTeste.maturidadeEEmotividade && {
            maturidadeEEmotividade: item.resultadoTeste.maturidadeEEmotividade
          }),
          ...(item.resultadoTeste.impulsividade && {
            impulsividade: item.resultadoTeste.impulsividade
          }),
          ...(item.resultadoTeste.relacionamentoInterpessoal && {
            relacionamentoInterpessoal:
              item.resultadoTeste.relacionamentoInterpessoal
          }),
          ...(item.resultadoTeste.energiaVitalProdutividade && {
            energiaVitalProdutividade:
              item.resultadoTeste.energiaVitalProdutividade
          }),
          ...(item.resultadoTeste.alterecaoPsiquicas && {
            alterecaoPsiquicas: item.resultadoTeste.alterecaoPsiquicas
          }),
          incluirBloco: item?.resultadoTeste?.customTeste
            ? false
            : item?.resultadoTeste?.incluirBloco,
          numeroPontos: item?.resultadoTeste?.numeroPontos,
          percentil: item?.resultadoTeste?.percentil,
          resultado: item?.resultadoTeste?.resultado,
          observacao: item?.resultadoTeste?.observacao,
          data: item?.resultadoTeste?.data
            ? item?.resultadoTeste?.data
            : dateToday
        }
      })
    }

    try {
      setLoading(true)
      await updateDetailingScreenplay().update(body)
      alert.show('Atulizado', {
        type: 'success',
        timeout: 4000
      })

      modalClose()
    } catch (error) {
      console.error(error)
      alert.show('Erro ao atualizar modelo', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  const saveNewScreenplay = async () => {
    const body = {
      roteiroTeste: {
        roteiroTeste: newScreenplayTitle
      },
      roteiroTesteDetalhamento: blocksInScreen.map(
        (item: BlockApplicationModel) => {
          return {
            construto: {
              cdConstruto: item?.construto?.cdConstruto
            },
            customTeste: item?.resultadoTeste?.customTeste,
            teste: item?.resultadoTeste?.teste?.cdTeste
              ? {
                  cdTeste: item?.resultadoTeste?.teste?.cdTeste
                }
              : undefined,
            ...(item.resultadoTeste.controleGeral && {
              controleGeral: item.resultadoTeste.controleGeral
            }),
            ...(item.resultadoTeste.afetividade && {
              afetividade: item.resultadoTeste.afetividade
            }),
            ...(item.resultadoTeste.organizacaoDaPersonalidade && {
              organizacaoDaPersonalidade:
                item.resultadoTeste.organizacaoDaPersonalidade
            }),
            ...(item.resultadoTeste.agressividade && {
              agressividade: item.resultadoTeste.agressividade
            }),
            ...(item.resultadoTeste.maturidadeEEmotividade && {
              maturidadeEEmotividade: item.resultadoTeste.maturidadeEEmotividade
            }),
            ...(item.resultadoTeste.impulsividade && {
              impulsividade: item.resultadoTeste.impulsividade
            }),
            ...(item.resultadoTeste.relacionamentoInterpessoal && {
              relacionamentoInterpessoal:
                item.resultadoTeste.relacionamentoInterpessoal
            }),
            ...(item.resultadoTeste.energiaVitalProdutividade && {
              energiaVitalProdutividade:
                item.resultadoTeste.energiaVitalProdutividade
            }),
            ...(item.resultadoTeste.alterecaoPsiquicas && {
              alterecaoPsiquicas: item.resultadoTeste.alterecaoPsiquicas
            }),
            incluirBloco: item?.resultadoTeste?.customTeste
              ? false
              : item?.resultadoTeste?.incluirBloco,
            numeroPontos: item?.resultadoTeste?.numeroPontos,
            percentil: item?.resultadoTeste?.percentil,
            resultado: item?.resultadoTeste?.resultado,
            observacao: item?.resultadoTeste?.observacao,
            data: item?.resultadoTeste?.data
              ? item?.resultadoTeste?.data
              : dateToday
          }
        }
      )
    }

    try {
      setLoading(true)
      await saveDetailingScreenplay().post(body)
      alert.show('Salvo', {
        type: 'success',
        timeout: 4000
      })

      modalClose()
    } catch (error) {
      console.error(error)
      alert.show('Erro ao incluir novo modelo', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {screenplaysSuggested.length > 0 && (
        <>
          <S.ModelsTitle>Roteiros sugeridos</S.ModelsTitle>
          <S.ModelsList>
            {screenplaysSuggested.map((item, index) => (
              <S.ModelsListItem
                key={`${item.cdRoteiroTeste}-${item.roteiroTeste}-${index}`}
              >
                {item.roteiroTeste}
                <S.ModelsIconButton
                  onClick={() => {
                    LoadBlockModal(item.cdRoteiroTeste)
                  }}
                  title="Carregar"
                >
                  <ArrowRightSvg />
                </S.ModelsIconButton>
              </S.ModelsListItem>
            ))}
          </S.ModelsList>
        </>
      )}
      {screenplaysCustom.length > 0 && (
        <>
          <S.ModelsTitle>Meus roteiros personalizados</S.ModelsTitle>
          <S.ModelsList>
            {screenplaysCustom.map((item, index) => (
              <S.ModelsListItem
                key={`${item.cdRoteiroTeste}-${index}-${item.roteiroTeste}`}
              >
                {item.roteiroTeste}
                <S.ModelsIconButtonContainer>
                  <S.ModelsIconButton
                    onClick={() => {
                      handleRemoveBlock()
                      LoadBlockModal(item.cdRoteiroTeste)
                    }}
                    title="Carregar"
                  >
                    <ArrowRightSvg />
                  </S.ModelsIconButton>
                  <S.ModelsIconButton onClick={updateScreenplay} title="Salvar">
                    <IconSaveSvg className="save-icon" />
                  </S.ModelsIconButton>
                  <S.ModelsIconButton
                    onClick={() => handleDeleteScreenplay(item.cdRoteiroTeste)}
                    disabled={loading}
                    title="Deletar"
                  >
                    <IconTrashSvg className="trash-icon" />
                  </S.ModelsIconButton>
                </S.ModelsIconButtonContainer>
              </S.ModelsListItem>
            ))}
          </S.ModelsList>
        </>
      )}
      <S.ModelsInputAndButtonContainer>
        <Input
          name="newModel"
          type="text"
          onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
            setNewScreenplayTitle(target.value)
          }
          value={newScreenplayTitle}
        />
        <Button
          disabled={!newScreenplayTitle || loading}
          onClick={saveNewScreenplay}
        >
          Incluir novo
        </Button>
      </S.ModelsInputAndButtonContainer>
    </>
  )
}

export default ModelsModal
